import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { PhotosGuideSidebar } from 'components/settings/PhotosGuideSidebar/index';

interface Params {
  node: HTMLElement;
}

export const PhotosGuideSidebarInitializer = (params: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(params.node),
  render: () => {
    ReactDOM.render(<PhotosGuideSidebar />, params.node);
  },
});
